import NextLink from 'next/link';
import { Heading, Skeleton } from '@wwtr/components/ui';
import { HeartIcon, LocationMarkerIcon } from '@heroicons/react/solid';
import React from 'react';
import cn from 'classnames';
import { OfficeBuildingIcon } from '@heroicons/react/outline';

export type SearchListingListItemProps = {
  id?: string;
  markerId?: string;
  title?: string;
  address?: string;
  department?: string;
  departmentTitle?: string;
  uri?: string;
  isLoading: boolean;
  isFavorite?: boolean;
  mouseEnter?: ($event: any, entryId: string) => void;
  mouseLeave?: ($event: any, entryId: string) => void;
  onFavoriteClick?: ($event: any, entryId: string) => void;
};

export const SearchListingListItem = ({
  id,
  markerId,
  title,
  address,
  department,
  departmentTitle,
  uri,
  isLoading,
  isFavorite = false,
  mouseEnter,
  mouseLeave,
  onFavoriteClick,
}: SearchListingListItemProps) => {
  return isLoading ? (
    <div className="block border-b border-gray-200 px-8 py-4">
      <div className="flex w-full flex-col">
        <div className="flex flex-1 flex-row justify-between">
          <Skeleton className={'w-56 h-4 mb-4'} />
          <Skeleton className={'w-6 h-6'} />
        </div>
        <Skeleton className={'w-32 h-2 mb-2'} />
        <Skeleton className={'w-20 h-2'} />
      </div>
    </div>
  ) : (
    <div
      className={cn(
        'block border-b border-gray-200 px-8 py-4 group hover:bg-gray-100',
        {}
      )}
      onMouseEnter={$event => mouseEnter($event, markerId)}
      onMouseLeave={$event => mouseLeave($event, markerId)}
    >
      <div className="flex items-start justify-between">
        <div>
          <Heading
            level={7}
            as="h3"
            className="group-hover:underline text-powerblue font-semibold"
          >
            <NextLink href={`/${uri}`}>
              <a href={`/${uri}`} title={`Lees meer over ${title}`}>
                {title}
              </a>
            </NextLink>
          </Heading>
          <p className="text-sm text-gray-500" title={`Bezoekadres ${title}`}>
            <LocationMarkerIcon className="inline align-text-top w-4 h-4 mr-1" />
            {address}
          </p>
          <p className="text-sm text-gray-500" title={departmentTitle}>
            <OfficeBuildingIcon className="inline align-text-top w-4 h-4 mr-1" />
            {department}
          </p>
        </div>
        <button
          className={cn(
            'ml-4 transform transition-transform duration-200 active:scale-125',
            {
              'text-hotpink': isFavorite,
              'text-gray-400 hover:text-hotpink': !isFavorite,
            }
          )}
          title={
            isFavorite ? 'Verwijder uit favorieten' : 'Opslaan in favorieten'
          }
          onClick={$event => onFavoriteClick($event, markerId)}
        >
          <HeartIcon className="w-6" />
        </button>
      </div>
    </div>
  );
};
